import React from "react";

const projects = [
  {
    title: "ERP-Dashboard",
    description: "Webanwendung zur Anzeige und Bearbeitung von Unternehmensdaten. Enthält Benutzerverwaltung, Diagramme und Exportfunktionen.",
    image: "/images/projekt1.jpg",
    video: "/videos/projekt1.mp4",
    technologies: "React Node.js MongoDB || PHP HTML CSS Javascript"
  },
  {
    title: "Excel VBA",
    description: "Excel-Datei verbunden mit einer SQL-Datenbank. Automatisierte Berichte, Datenimport/-export und Benutzerrollen.",
    image: "/images/projekt2.jpg",
    video: "/videos/projekt2.mp4",
    technologies: "Excel VBA SQL Microsoft Ribbon-Editor"
  },
  {
    title: "Portfolio Website",
    description: "Persönliche Portfolio-Seite mit Kontaktformular, animierten Komponenten und responsivem Design.",
    image: "/images/projekt3.jpg",
    video: "",
    technologies: "React TailwindCSS"
  },
  {
    title: "Support für bestehende Software",
    description: "Support und Anpassung von bestehender Software",
    image: "/images/projekt4.jpg",
    video: "",
    technologies: "Node.js Express OpenWeatherMap API"
  }
];

function Projects() {
  return (
    <section id="projects" className="max-w-6xl mx-4 md:mx-auto mt-12 md:mt-16">
      <div className="text-left mb-6 md:mb-8">
        <p className="uppercase tracking-[0.16em] text-xs font-bold text-cyan-700 mb-2">Portfolio</p>
        <h2 className="text-3xl md:text-4xl font-black text-slate-900">Meine Projekte</h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
        {projects.map((project, idx) => (
          <article key={idx} className="glass-card p-5 md:p-6 text-left">
            <h3 className="text-xl md:text-2xl font-bold text-slate-900">{project.title}</h3>
            <p className="text-slate-600 mt-2">{project.description}</p>
            <p className="text-slate-600 mt-2">{project.technologies}</p>

            

            <video
              src={project.video}
              controls
              className="w-full rounded-xl mt-3 border border-slate-200"
            />

          </article>
        ))}
      </div>
    </section>
  );
}

export default Projects;